module.exports = __webpack_public_path__ + "static/media/picto-close-blue.7221c632.svg";